import type { ReducerAction } from 'utils/types';

import type { IAppContext } from './types';
import { appContext } from './context';

export const appReducer = (
  store: IAppContext = appContext,
  action: ReducerAction<keyof IAppContext>,
) => {
  switch (action.type) {
    case 'ssoAccessToken': {
      return { ...store,
        [action.type]: action.payload };
    }
    default: return store;
  }
};
